
const userprofile = [{"key":"userprofile.title","string":"Ihr Profil für die Gelben Seiten"},{"key":"userprofile.button.update_profile","string":"Profil ändern"},{"key":"userprofile.no_profile","string":"Sie haben noch kein Profil für die Gelben Seiten erstellt."}]

export default userprofile



// WEBPACK FOOTER //
// ./src/i18n/de/adduserprofile/userprofile.js